import { composeDataModules } from '@perpay-web/data-module/composeDataModules';
import { fetchFeatureEnrollmentsForPerpayPlusDataModule } from '@perpay-web/fintech/dataModules/fetchFeatureEnrollmentsForPerpayPlus';
import { fetchUserInfoDataModule } from '@perpay-web/fintech/dataModules/fetchUserInfo';

const CheckoutDataModule = composeDataModules([
    fetchUserInfoDataModule,
    fetchFeatureEnrollmentsForPerpayPlusDataModule,
]);

const getRoot = (state) => state.dataModules.checkout;

export const checkoutDataModule = CheckoutDataModule({
    getRoot,
    key: 'CHECKOUT',
});
